import { graphql } from '@/utils/graphql';

export const matchdayCardDateFragment = graphql(`
  fragment matchdayCardDateFields on matchdays {
    start_datetime
    postponed
    country {
      translations(filter: { languages_code: { code: { _eq: $language } } }) {
        name
      }
    }
    location {
      name
      timezone
    }
  }
`);
